import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Sun6pm = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99988 1.31598C7.6547 1.31598 7.37488 1.5958 7.37488 1.94098V3.05897C7.37488 3.40415 7.6547 3.68397 7.99988 3.68397C8.34506 3.68397 8.62488 3.40415 8.62488 3.05897V1.94098C8.62488 1.5958 8.34506 1.31598 7.99988 1.31598Z"
        fill="currentColor"
      />
      <path
        d="M7.99988 12.316C7.6547 12.316 7.37488 12.5958 7.37488 12.941V14.059C7.37488 14.4041 7.6547 14.684 7.99988 14.684C8.34506 14.684 8.62488 14.4041 8.62488 14.059V12.941C8.62488 12.5958 8.34506 12.316 7.99988 12.316Z"
        fill="currentColor"
      />
      <path
        d="M1.94092 8.625C1.59574 8.625 1.31592 8.34518 1.31592 8C1.31592 7.65482 1.59574 7.375 1.94092 7.375H3.05891C3.40409 7.375 3.68391 7.65482 3.68391 8C3.68391 8.34518 3.40409 8.625 3.05891 8.625H1.94092Z"
        fill="currentColor"
      />
      <path
        d="M12.3159 8C12.3159 8.34518 12.5957 8.625 12.9409 8.625H14.0589C14.4041 8.625 14.6839 8.34518 14.6839 8C14.6839 7.65482 14.4041 7.375 14.0589 7.375H12.9409C12.5957 7.375 12.3159 7.65482 12.3159 8Z"
        fill="currentColor"
      />
      <path
        d="M3.27363 4.15758C3.02956 3.9135 3.02956 3.51778 3.27363 3.2737C3.51771 3.02962 3.91344 3.02962 4.15752 3.2737L4.94806 4.06424C5.19213 4.30832 5.19213 4.70404 4.94806 4.94812C4.70398 5.1922 4.30825 5.1922 4.06417 4.94812L3.27363 4.15758Z"
        fill="currentColor"
      />
      <path
        d="M11.0517 11.0519C10.8076 11.296 10.8076 11.6917 11.0517 11.9358L11.8423 12.7263C12.0863 12.9704 12.4821 12.9704 12.7261 12.7263C12.9702 12.4822 12.9702 12.0865 12.7261 11.8424L11.9356 11.0519C11.6915 10.8078 11.2958 10.8078 11.0517 11.0519Z"
        fill="currentColor"
      />
      <path
        d="M4.15761 12.7263C3.91354 12.9704 3.51781 12.9704 3.27373 12.7263C3.02965 12.4822 3.02965 12.0865 3.27373 11.8424L4.06427 11.0519C4.30835 10.8078 4.70407 10.8078 4.94815 11.0519C5.19223 11.296 5.19223 11.6917 4.94815 11.9358L4.15761 12.7263Z"
        fill="currentColor"
      />
      <path
        d="M11.0518 4.94817C11.2959 5.19225 11.6916 5.19225 11.9357 4.94817L12.7262 4.15763C12.9703 3.91355 12.9703 3.51782 12.7262 3.27374C12.4822 3.02967 12.0864 3.02967 11.8423 3.27374L11.0518 4.06428C10.8077 4.30836 10.8077 4.70409 11.0518 4.94817Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.48898 10.8043C6.14652 11.4182 7.02934 11.794 7.99993 11.794C10.0323 11.794 11.6799 10.1464 11.6799 8.11399C11.6799 6.08158 10.0323 4.43399 7.99993 4.43399C7.02976 4.43399 6.14728 4.80942 5.48983 5.42291C5.45183 5.45792 5.4146 5.49416 5.37818 5.53159C4.72376 6.19592 4.31993 7.10779 4.31993 8.11399C4.31993 9.12061 4.72409 10.0328 5.37899 10.6972C5.41489 10.7341 5.45156 10.7698 5.48898 10.8043ZM10.4299 8.11399C10.4299 7.16028 9.88051 6.33489 9.08092 5.93707C9.48238 6.52144 9.7251 7.28217 9.7251 8.11399C9.7251 8.94581 9.48238 9.70655 9.08091 10.2909C9.88051 9.8931 10.4299 9.06771 10.4299 8.11399Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Sun6pm;
